import React from "react";
import { useLocation } from "react-router-dom";

export const SidebarLayoutContext = React.createContext(false);

export const useIsSidebarLayout = () => {
  return React.useContext(SidebarLayoutContext);
};

export interface SidebarActiveItem {
  path: string;
  title: string;
}

export const SidebarActiveItemContext =
  React.createContext<SidebarActiveItem | null>(null);

/**
 * Returns the active sidebar item only when the current page is the landing
 * page of that item (exact path, reached from the menu and not from a
 * contextual navigation carrying router state).
 */
export const useSidebarLandingItem = (): SidebarActiveItem | null => {
  const activeItem = React.useContext(SidebarActiveItemContext);
  const location = useLocation();
  if (!activeItem || location.state) return null;
  const pathname = location.pathname.replace(/\/+$/, "");
  return pathname === activeItem.path ? activeItem : null;
};
